import React, { useState, useEffect, useGlobal } from "reactn";
import { MiniPlus } from "../../../assets";
import NewAutomationModal from "../../../components/modals/NewAutomationModal";
import EmailTemplateModal from "../../../components/modals/EmailTemplateModal";
import TextTemplateModal from "../../../components/modals/TextTemplateModal";
import AutomationCard from "./AutomationCard";
import axios from "axios";
import { toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import { useHistory } from "react-router-dom";

const Automations = () => {
  const history = useHistory();
  const [partnerPathway, setPartnerPathway] = useGlobal("partnerPathway");
  const [organizationInfo, setOrganizationInfo] = useGlobal("organizationInfo");
  const [openNewAutomation, setOpenNewAutomation] = useState(false);
  const [automations, setAutomations] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [openTemplateModal, setOpenTemplateModal] = useState(false);
  const [openTextTemplateModal, setOpenTextTemplateModal] = useState(false);
  const [editAutomation, setEditAutomation] = useState(null);
  const [hasTwilioPhone, setHasTwilioPhone] = useState(false);

  useEffect(() => {
    setPartnerPathway([
      ...partnerPathway.slice(0, 1),
      { label: "Automations", to: "/automations" }
    ]);
    fetchAutomations();
    fetchTemplates();
    fetchPartnerTwilioPhone();
  }, []);

  const fetchPartnerTwilioPhone = async () => {
    try {
      const ep = `${process.env.REACT_APP_API}/partners/automations/partner-twilio-phone`;
      const response = await axios.get(ep);
      if (response.data.success) {
        setHasTwilioPhone(response.data.data.hasTwilioPhone);
      }
    } catch (error) {
      console.error("Error fetching partner Twilio phone:", error);
    }
  };

  const handleCreateNew = (type) => {
    if (type === "text" && !hasTwilioPhone) {
      toast.error("Contact Dreamschools support to set up SMS capabilities for your account");
      return;
    }

    const initialAutomation = {
      communicationType: type,
      automationType: "",
      automationFor: "",
      audience: [],
      templateId: "",
      timing: "",
      timingUnit: "",
      enabled: true,
      isArchived: false
    };
    
    localStorage.setItem('currentAutomation', JSON.stringify(initialAutomation));
    
    history.push({
      pathname: "/partners/automations/setup",
      state: { initialAutomation }
    });
  };

  const fetchAutomations = async () => {
    try {
      const ep = `${process.env.REACT_APP_API}/partners/automations`;
      const response = await axios.get(ep);
      if (response.data.success) {
        setAutomations(response.data.data);
      }
      console.log("Automations", response.data);
    } catch (error) {
      console.error("Error fetching automations:", error);
      toast.error("Failed to load automations");
    }
  };
  const fetchTemplates = async () => {
    try {
      const ep = `${process.env.REACT_APP_API}/partners/connections`;
      const results = await axios.get(ep);
      if (results.data.success) {
        setTemplates(results.data.data.templates);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const handleSubmit = async data => {
    try {
      console.log("Automations.jsx received data:", data); 
      const ep = `${process.env.REACT_APP_API}/partners/automations`;
      const requestData = {
        communicationType: data.communicationType,
        automationFor: data.automationFor,
        automationType: data.automationType,
        templateId: data.templateId,
        timing: data.timing,
        timingUnit: data.timingUnit,
        ...(data.id && { id: data.id })
      };
  
      const response = await axios.post(ep, requestData);

      if (response.data.success) {
        toast.success(editAutomation ? "Automation updated successfully" : "Automation created successfully");
        setOpenNewAutomation(false);
        fetchAutomations();
      } else {
        toast.error(response.data.message || "Failed to create automation");
      }
    } catch (error) {
      console.error("Error creating automation:", error);
      toast.error("Failed to create automation");
    }
  };

  const handleEdit = (automation) => {
    let parsedAudience = [];
    if (automation.audience) {
      try {
        if (Array.isArray(automation.audience)) {
          parsedAudience = automation.audience;
        } else {
          parsedAudience = JSON.parse(automation.audience);
        }
      } catch (error) {
        console.error("Error parsing audience:", error);
        parsedAudience = [];
      }
    }
    
    const automationWithParsedAudience = {
      ...automation,
      audience: parsedAudience
    };
    
    localStorage.setItem('currentAutomation', JSON.stringify(automationWithParsedAudience));
    
    history.push({
      pathname: `/partners/automations/setup/${automation.id}`,
      state: { initialAutomation: automationWithParsedAudience }
    });
  }
  const handleToggleAutomation = async id => {
    try {
      const automation = automations.find(a => a.id === id);
      const ep = `${process.env.REACT_APP_API}/partners/automations/toggle`;
      const response = await axios.post(ep, {
        id: automation.id,
        enabled: !automation.enabled
      });

      if (response.data.success) {
        setAutomations(
          automations.map(a =>
            a.id === id ? { ...a, enabled: !a.enabled } : a
          )
        );
        toast.success("Automation updated successfully");
      }
    } catch (error) {
      console.error("Error toggling automation:", error);
      toast.error("Failed to update automation");
    }
  };

  const handleDeleteAutomation = async id => {
    if (window.confirm("Are you sure you want to archive this automation?")) {
      try {
        const ep = `${process.env.REACT_APP_API}/partners/automations/archive`;
        const response = await axios.post(ep, { id });

        if (response.data.success) {
          setAutomations(automations.filter(a => a.id !== id));
          toast.success("Automation archived successfully");
        }
      } catch (error) {
        console.error("Error archiving automation:", error);
        toast.error("Failed to archive automation");
      }
    }
  };

  return (
    <div className="admin">
      <EmailTemplateModal
        onSave={fetchTemplates}
        onClose={() => setOpenTemplateModal(false)}
        open={openTemplateModal}
        allTemplates={[...templates]}
      />
      <TextTemplateModal
        onSave={fetchTemplates}
        onClose={() => setOpenTextTemplateModal(false)}
        open={openTextTemplateModal}
        allTemplates={[...templates]}
      />
      <div className="container-fluid adminprofiles">
        <div className="row cont">
          <div className="col-md-6">
            <h1>Communication Automations</h1>
            <p>
              Set up custom email or text notifications to automatically communicate
              with customers
            </p>
          </div>
          <div className="col-md-6">
            <div className="forbtnwrap justify-end">
              <div className="forbtnapp" style={{ marginRight: "20px" }}>
              <Dropdown
                  button
                  className="newapplications"
                  text="Edit Templates"
                  style={{
                    cursor: "pointer",
                    paddingLeft: "20px",
                    zIndex: "1000"
                  }}
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      text="Email Templates"
                      onClick={() => setOpenTemplateModal(true)}
                    />
                    <Dropdown.Item
                      text="Text Templates"
                      onClick={() => setOpenTextTemplateModal(true)}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {/*<div className="forbtnapp">
                <button
                  className="newapplications"
                  disabled={false}
                  style={{
                    cursor: "pointer"
                  }}
                  onClick={_ => {
                    setOpenNewAutomation(true);
                    setEditAutomation(null);
                  }}
                >
                  <img src={MiniPlus} alt="" style={{ alignSelf: "center" }} />
                  Delete Later
                </button>
              </div>
                */}
              <div className="forbtnapp">
              <Dropdown
                  button
                  className="newapplications"
                  text="Create New"
                  style={{
                    cursor: "pointer",
                    paddingLeft: "20px",
                    zIndex: "1000",
                  }}
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      text="Email"
                      onClick={() => {
                        handleCreateNew("email");
                      }}
                    />
                    <Dropdown.Item
                      text="Text/SMS"
                      onClick={() => {
                        handleCreateNew("text");
                      }}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <div className="cont">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "20px",
              padding: "20px 0"
            }}
          >
            {automations.map(automation => (
              <AutomationCard
                key={automation.id}
                automation={automation}
                onToggle={handleToggleAutomation}
                onDelete={handleDeleteAutomation}
                templates={templates}
                onEdit={handleEdit}
              />
            ))}
            {automations.length === 0 && (
              <div
                style={{
                  gridColumn: "1 / -1",
                  textAlign: "center",
                  padding: "40px",
                  color: "#666"
                }}
              >
                No automations created yet. Click "Create New" to get started.
              </div>
            )}
          </div>
        </div>
      </div>
      {openNewAutomation && (
        <NewAutomationModal
          onClose={() => {
            setOpenNewAutomation(false);
            setEditAutomation(null);
            fetchAutomations(); 
          }}
          onSubmit={data => handleSubmit(data)}
          templates={templates}
          editAutomation={editAutomation}
        />
      )}
    </div>
  );
};

export default Automations;
